import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { FriendOverview } from './types';

export interface FriendOverviewFilters {
  from?: string;
  to?: string;
}

export function useFriendOverview(filters: FriendOverviewFilters) {
  const { request } = useAdminApi();
  const [data, setData] = useState<FriendOverview | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(
        await request<FriendOverview>({
          env: 'prod',
          path: '/admin/analytics/friends/overview',
          query: filters as Record<string, string | number | undefined>,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load overview');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
